module.exports = __webpack_public_path__ + "static/media/slide_10.0effb33b.jpg";